export default __webpack_public_path__ + "static/media/pub4.9f312294.png";